module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_8019.238a3d95.png";